export default __webpack_public_path__ + "static/media/person.4c391b27.svg";